import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss';

const NotFound = () => {
    useEffect(() => {
        document.title = '404 — Page Not Found';
    }, []);

    return (
        <section className="section-wrapper page not-found">
            <div className="section-inner">
                <h1 className="page-title">404 — Page Not Found</h1>
                <div className="not-found__content">
                    <p>Sorry, the page you're looking for doesn't exist.</p>
                    <Link to="/" className="btn btn-primary">Go to Home</Link>
                </div>
            </div>
        </section>
    );
};

export default NotFound;
